import { DESTINATION_TYPES } from '../../../constants';
import type { AddressFormSectionClientProps, DestinationType } from '../../../types';
import { getDestinationTypeFromShippingCategory } from './getDestinationTypeFromShippingCategory';

/** Chooses the initial destination: a saved private/company shipping address wins over a supported pickup point. */
export function getInitialDestinationTypeFromSavedAddresses(
  supportsPickupPoints: boolean,
  pickupPointAddress: AddressFormSectionClientProps['pickupPointAddress'],
  shippingAddress: AddressFormSectionClientProps['shippingAddress']
): DestinationType | undefined {
  const shippingDestinationType = getDestinationTypeFromShippingCategory(shippingAddress?.category);

  if (shippingDestinationType && shippingDestinationType !== DESTINATION_TYPES.PICKUP_POINT) {
    return shippingDestinationType;
  }

  if (supportsPickupPoints && pickupPointAddress) {
    return DESTINATION_TYPES.PICKUP_POINT;
  }

  return shippingDestinationType;
}